module.exports = function() {
  return new Worker(__webpack_public_path__ + "b4eb7fd2a335a1cbfed5.worker.js");
};